import React from 'react'
import { FormHeaderProps } from '../types'

const FormHeader: React.FC<FormHeaderProps> = ({ isRegister }) => {
  return (
    <>
        <h1 className="text-xl lg:text-3xl 2xl:text-4xl font-bold lg:font-medium text-secondaryNeutral-12">
            {isRegister ? "Get started!" : "Welcome back!"}
        </h1>

        <p className="mt-2 text-sm lg:text-base 2xl:text-lg font-light text-secondaryNeutralAlpha-11 opacity-[62.75%]">
            {isRegister ? 
            "Welcome to Kreaitor AI - Let's create your account" : 
            "Enter your login info to pick up where you left off"}
        </p>
    </>
  )
}

export default FormHeader
